import React from "react";
import Button from "../button/Button";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useParams, useLocation } from "react-router-dom";

// Helper function to get team label from team slug
function getTeamLabel(team) {
    const teamLabels = {
        "northeastern-ontario": "⬅ Northeastern Ontario",
        "algoma-country": "⬅ Algoma Country", 
        "superior-country": "⬅ Superior Country",
        "sunset-country": "⬅ Sunset Country"
    };
    return teamLabels[team] || null;
}

function AppHeader({ tenantInfo }) {
    const { team } = useParams();
    const location = useLocation();
    
    
    // Map tenant label to subportal_url if subportal_url is not provided
    const getSubportalUrl = (tenant) => {
        if (tenant?.subportal_url) {
            return tenant.subportal_url;
        }
        
        // Map tenant labels to known subportal URLs
        const labelToSubportal = {
            'Northeastern Ontario': 'northeastern-ontario',
            'Algoma Country': 'algoma-country', 
            'Superior Country': 'superior-country',
            'Sunset Country': 'sunset-country',
            'Thunder Bay': 'thunder-bay'
        };
        
        return tenant?.label ? labelToSubportal[tenant.label] : null;
    };
    
    // Use tenant info if provided, otherwise fall back to team param
    const subportalUrl = getSubportalUrl(tenantInfo) || team;
    const backButtonUrl = subportalUrl ? `https://northernontario.travel/${subportalUrl}` : null;
    
    const backButtonLabel = tenantInfo?.label 
        ? `⬅ ${tenantInfo.label}`
        : getTeamLabel(team);
    return (
        <div className="trpr__app-header-container">
            <div
                className="trpr__app-header"
                css={css`
                    justify-content: space-between !important;
                `}
            >
                <div className="is-invisible-mobile">
                    {backButtonUrl && backButtonLabel && (
                        <a href={backButtonUrl}>
                            <Button>{backButtonLabel}</Button>
                        </a>
                    )}
                </div>
                <div
                    css={css`
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                        padding: 20px;
                        text-align: center;
                        font-family: new-spirit-condensed, Georgia, "Times New Roman", times, serif;
                        color: white !important;
                        white-space: nowrap;
                        user-select: none;
                        -webkit-user-select: none;
                    `}
                >
                    <a 
                        href="https://northernontario.travel"
                        css={css`
                            color: inherit !important;
                            text-decoration: none !important;
                            font-family: inherit;
                            font-size: inherit;
                            font-weight: inherit;
                        `}
                    >
                        Northern Ontario Travel • The Official Magazine
                    </a>
                </div>
                <div
                    css={css`
                        display: flex;
                        align-items: center;
                        padding: 20px;
                    `}
                >
                    {location.pathname !== "/" && (
                        <a
                            href="/"
                            css={css`
                                color: white !important;
                                text-decoration: none !important;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                width: 40px;
                                height: 40px;
                                border-radius: 4px;
                                transition: background-color 0.2s ease;
                                
                                &:hover {
                                    background-color: rgba(255, 255, 255, 0.1);
                                }
                            `}
                            title="View Maps"
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M20.5 3L20.34 3.03L15 5.1L9 3L3.36 4.9C3.15 4.97 3 5.15 3 5.38V20.5C3 20.78 3.22 21 3.5 21L3.66 20.97L9 18.9L15 21L20.64 19.1C20.85 19.03 21 18.85 21 18.62V3.5C21 3.22 20.78 3 20.5 3ZM15 19L9 17V5L15 7V19Z"
                                    fill="currentColor"
                                />
                            </svg>
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
}

export default AppHeader;
